<app-content-header i18n-title title="User Information" i18n-subTitle
                    subTitle="Information about {{userId}}"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
                    *ngIf="user != null"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>

<div class="content">
  <div class="row">
    <div class="col-6 offset-3">
      <tripmakery-user-info-user-edit *ngIf="user != null" [user]="user"></tripmakery-user-info-user-edit>
    </div>
  </div>

  <div class="row" *ngIf="user != null && user.states?.isHousingUserAccount === true">
    <div class="col-12">
      <h4>Housing Access</h4>
      <tripmakery-user-info-housing-access [user]="user"></tripmakery-user-info-housing-access>
    </div>
  </div>
</div>

